import { Controller } from "@hotwired/stimulus";
import { ThemeEvents } from "@theme/events";

class DiscountKitVolumeTiersController extends Controller {
  static targets = ["tier"];
  static values = {
    discountedPrice: String,
  };
  static outlets = ["price"];

  connect() {
    this._boundOnQuantityChange = this.#onQuantityChange.bind(this);
    document.addEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this._boundOnQuantityChange,
    );
  }

  disconnect() {
    document.removeEventListener(
      ThemeEvents.quantitySelectorUpdate,
      this._boundOnQuantityChange,
    );
  }

  /**
   * Handles QuantitySelectorUpdateEvent change event.
   * @param {QuantitySelectorUpdateEvent} event - The event.
   */
  #onQuantityChange(event) {
    const { quantity, cartLine: line } = event.detail;

    if (line) return;

    this.setActiveTierByTierBuy(quantity);
  }

  #updatePrice(price) {
    this.priceOutlet.updatePrice({
      price,
    });
  }

  setActiveTier(target, quantity) {
    const tierElement = target instanceof Event ? target.currentTarget : target;

    if (tierElement.dataset.activeTier == "true") {
      return;
    }
    this.tierTargets.forEach((tier) => {
      tier.dataset.activeTier = "false";
    });
    tierElement.dataset.activeTier = "true";

    const qty = document.querySelector("quantity-selector-component");
    qty.quantityInput.value = quantity ?? tierElement.dataset.tierBuy;
    qty.updateButtonStates();

    this.#updatePrice(tierElement.dataset.price);
  }

  setActiveTierByTierBuy(quantity) {
    this.tierTargets.forEach((tier, idx, tiers) => {
      const currentTierBuy = Number(tier.dataset.tierBuy);
      const nextTier = tiers[idx + 1];
      const nextTierBuy = nextTier
        ? Number(nextTier.dataset.tierBuy)
        : Infinity;

      const shouldBeActive =
        idx === 0
          ? quantity >= 1 && quantity < nextTierBuy
          : quantity >= currentTierBuy && quantity < nextTierBuy;

      if (shouldBeActive) {
        this.setActiveTier(tier, quantity);
      }
    });
  }
}

Stimulus.register(
  "discount-kit-volume-tiers",
  DiscountKitVolumeTiersController,
);
